import { Component, Input, OnInit, inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { VisitTypeStore } from "@app/services/store/visit-type-store";
import { VisitTypeAddComponent } from "@app/view/setup/assignment/visit-type-add/visit-type-add.component";
import { BaseDataTablePageDirective } from "@app/view/shared/base-pages/base-data-table-page/base-data-table-page.directive";
import { SystemSearchMetaRestService } from "@app/services/hal/system-search-meta-rest.service";
import { UntypedFormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { VisitType } from "@app/models/rest/visit-type";
import { MatToolbar } from "@angular/material/toolbar";
import { MatButton } from "@angular/material/button";
import { GridComponent } from "../../../shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-visit-type-list",
  templateUrl: "./visit-type-list.component.html",
  styleUrls: ["./visit-type-list.component.scss"],
  imports: [MatToolbar, MatButton, GridComponent, MatPaginator, TranslatePipe]
})
export class VisitTypeListComponent
  extends BaseDataTablePageDirective<VisitType>
  implements OnInit
{
  visitTypeStore: VisitTypeStore;
  protected store: Store<any>;
  protected dialog: MatDialog;
  protected formBuilder: UntypedFormBuilder;
  protected router = inject(Router);
  serverErrorHandler: ServiceErrorHandlerService;
  protected ngxUiLoaderService: NgxUiLoaderService;

  @Input()
  public columns: object[] = [
    // {
    //   field: 'id',
    //   text: 'ID',
    //   flex: 1,
    //   editor: false
    // },
    {
      field: "description",
      text: "Description",
      flex: 1,
      editor: true
    },
    {
      field: "meeting",
      type: "check",
      text: "Meeting Type?",
      width: 100,
      editor: true
    },
    {
      type: "action",
      text: "Edit",
      width: 50,
      editor: false,
      actions: [
        {
          cls: "fa fa-pencil",
          tooltip: "Edit",
          onClick: ({ record }) => {
            if (record.meeting) {
              console.log("meeting type");
              this.serverErrorHandler.handleClientError(
                "Meeting types cannot be edited"
              );
              return;
            }
            if (isNaN(record.id)) {
              console.log("unsaved");
              this.serverErrorHandler.handleClientError(
                "Save changes before editing this record"
              );
              return;
            }
            this.router.navigate(["setup/assignment/visits", record.id]).then();
          }
        }
      ]
    }
  ];

  constructor() {
    const systemSearchMetaRestService = inject(SystemSearchMetaRestService);
    const visitTypeStore = inject(VisitTypeStore);
    const store = inject<Store<any>>(Store);
    const dialog = inject(MatDialog);
    const formBuilder = inject(UntypedFormBuilder);
    const serverErrorHandler = inject(ServiceErrorHandlerService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);

    super(
      systemSearchMetaRestService,
      visitTypeStore,
      store,
      dialog,
      "VisitType",
      formBuilder,
      serverErrorHandler,
      ngxUiLoaderService
    );

    this.visitTypeStore = visitTypeStore;
    this.store = store;
    this.dialog = dialog;
    this.formBuilder = formBuilder;
    this.serverErrorHandler = serverErrorHandler;
    this.ngxUiLoaderService = ngxUiLoaderService;
  }

  public get pristine() {
    return (
      !this.gridStore.changes ||
      (this.gridStore.changes.added.length === 0 &&
        this.gridStore.changes.removed.length === 0 &&
        this.gridStore.changes.modified.length === 0)
    );
  }

  ngOnInit() {
    super.ngOnInit();
    this.gridStore.autoCommit = false;
    this.gridStore.load({});
  }

  addRow() {
    this.gridStore.insert(0, {
      code: "",
      description: "",
      defaultDuration: 30,
      meeting: false
    });
  }

  openResource(id) {
    console.log("opening resource with id " + id);
    this.router.navigate(["setup/resourcing/resources", id]).then();
  }

  openNewVisitTypeDialog(): void {
    const dialogRef = this.dialog.open(VisitTypeAddComponent);
    // , {
    //   width: '350px',
    //   data: { mode: 'NEW' }
    // });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed");
      console.log(result);
      this.ngOnInit();
    });
  }
}
